import makeStyles from "@mui/styles/makeStyles";
import { TableProps } from "./Table.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: TableProps) => ({
    "& > thead": {
      background: props.headerBg,
      "& > tr": {
        "& > th": {
          "&:first-child": {
            paddingLeft:
              props.sidePadding !== undefined
                ? props.sidePadding * 4
                : undefined,
          },
          "&:last-child": {
            paddingRight:
              props.sidePadding !== undefined
                ? props.sidePadding * 4
                : undefined,
          },
        },
      },
    },
    "& > tbody": {
      "& > tr": {
        "& > td": {
          "&:first-child": {
            paddingLeft:
              props.sidePadding !== undefined
                ? props.sidePadding * 4
                : undefined,
          },
          "&:last-child": {
            paddingRight:
              props.sidePadding !== undefined
                ? props.sidePadding * 4
                : undefined,
          },
        },
      },
    },
  }),
  layoutFixed: {
    tableLayout: "fixed",
  },
  hideLastRowBorder: {
    "& > tbody": {
      "& > tr:last-child": {
        "& > td": {
          borderBottom: 0,
        },
      },
    },
  },
  borderless: {
    "& > thead": {
      "& > tr": {
        "& > th": {
          borderBottom: 0,
        },
      },
    },
    "& > tbody": {
      "& > tr": {
        "& > td": {
          borderBottom: 0,
        },
      },
    },
  },
  showBorderTop: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
}));
